
import axios from "axios";
import { BaseApiUrl } from "@/globals";
export default {
  name: "HistoricodeStatus",
  data: () => ({
    recorrencia: [],
    headers: [
      { text: "ID", value: "id", align: "center" },
      { text: "Contratante", value: "contratante" },
      { text: "Vendedor", value: "vendedor" },
      { text: "Plano", value: "plano" },
      { text: "Data", value: "data", align: "center" },
      { text: "Hora", value: "hora", align: "center" },
      { text: "Status da venda", value: "status_venda", align: "center" },
      { text: "Status da assinatura", value: "status_assinatura", align: "center" }

    ]
  }),
  methods: {
    getHistorico() {
      axios
        .get(`${BaseApiUrl}/relatorio/assinaturas`)
        .then(res => {
          this.recorrencia = res.data
        });
    }
  },
  mounted() {
    this.getHistorico();
  },
  filters: {
    dataFormatada: function(value) {
      let d = value.split("-");
      let dia = d[2].split("T")[0];
      let mes = d[1];
      let ano = d[0];

      return `${dia}/${mes}/${ano}`;
    },
    horaFormatada: function(value) {
      if (value) {
        let hora = value.split("T")[1].split(".")[0];
        return hora;
      }
    },
  }
};
